import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Descargas y Descubres',
    desc: 'Descargas la guía instantáneamente y aprendes los 3 disparadores ocultos que activan el modo combate de tu hijo.'
  }, {
    num: '2',
    title: 'Aplicas la Pausa',
    desc: "Aplicas la 'Gramática de Emergencia' en la próxima provocación. Notarás su confusión de inmediato al ver que no reaccionas como siempre."
  }, {
    num: '3',
    title: 'Recuperas el Control',
    desc: 'Implementas la Negociación Invisible para que las reglas de la casa se cumplan por puro interés de él, no por súplica tuya.'
  }];
  return <section className="py-24 px-4 bg-brand-slate border-y border-brand-charcoal relative" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <FadeIn data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-122">
            Cómo funciona el proceso
          </h2>
        </FadeIn>

        <div className="space-y-12 relative" data-id="element-123">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute left-8 top-10 bottom-10 w-0.5 bg-brand-charcoal z-0" data-id="element-124" />

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} direction="up" data-id="element-125">
              <div className="relative z-10 flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-126">
                <div className="w-16 h-16 rounded-full bg-brand-navy border-2 border-brand-gold flex items-center justify-center flex-shrink-0 shadow-glow-gold" data-id="element-127">
                  <span className="text-2xl font-playfair font-bold text-brand-gold" data-id="element-128">
                    {step.num}
                  </span>
                </div>
                <div className="bg-brand-navy/50 border border-brand-charcoal p-8 rounded-2xl flex-1" data-id="element-129">
                  <h3 className="text-2xl font-bold text-brand-cream mb-3" data-id="element-130">
                    {step.title}
                  </h3>
                  <p className="text-lg text-brand-gray" data-id="element-131">{step.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}